import React from 'react';
import { CloseModal } from 'assets/icons';

// The close button of company's modals (components/modal/components/closeButton
// there): a 40px square with the border of the SECONDARY button. Extra props
// reach the button.
const ModalCloseButton = ({ onClick, label, className = '', ...props }) => (
  <button
    type="button"
    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-gray-100 bg-white text-gray-700 hover:bg-gray-100 active:bg-gray-200 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500 ${className}`}
    onClick={onClick}
    aria-label={label}
    {...props}
  >
    <CloseModal />
  </button>
);

export default ModalCloseButton;
